/**
 * Created by sachinprakash on 12/8/19.
 */
import initialStates from '../../initialStates';
import {
    FETCH_POLICY_VIEW_LIST_FAILURE,
    FETCH_POLICY_VIEW_LIST_REQUEST,
    FETCH_POLICY_VIEW_LIST_SUCCESS,
} from './policyView-actions';

const policyView = (state = initialStates.policyView, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_POLICY_VIEW_LIST_REQUEST:
        newState = { ...state, isLoading: true };
        break;
    case FETCH_POLICY_VIEW_LIST_SUCCESS:
        newState = {
            ...state,
            isLoading: false,
            list: action.data.content,
            page: action.data.number,
            size: action.data.size,
            sortCol: action.sortCol,
            sortOrder: action.sortOrder,
            totalElements: action.data.totalElements,
            filters: action.filters,
        };
        break;
    case FETCH_POLICY_VIEW_LIST_FAILURE:
        newState = { ...state, isLoading: false };
        break;
    default:
        newState = state;
    }

    return newState;
};

export default policyView;
